var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6475 8.63309L10.1655 16.259L7 12.9496L20.0935 0L33.0432 12.9496L29.8777 16.259L22.3957 8.63309V15.6835H17.6475V8.63309ZM22.2518 18.705V23.741H17.6475V18.705H22.2518ZM22.2518 26.7626V31.7986H17.6475V26.7626H22.2518ZM22.2518 34.964V40H17.6475V34.964H22.2518Z",
    fill: "#580B8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDotted);
export default __webpack_public_path__ + "static/media/arrow_dotted.ae969cd89d226bc7d1e65ed5f6ca9d4f.svg";
export { ForwardRef as ReactComponent };